module.exports = __webpack_public_path__ + "static/media/icon_add.2e2afbe0.svg";